import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'pekingDate'
})
export class PekingDatePipe implements PipeTransform{
    constructor(private dataPipe: DatePipe){}

    transform(value: any, format = 'longDate'): any{
        if (!value) return '';

        const offsetTimestamp = new Date(value).getTimezoneOffset() * 60 * 1000;        // 获取时区偏移的毫秒数;
        const targetTimestamp = new Date(value + offsetTimestamp + (8 * 3600 * 1000));  // 转成北京时间

        return this.dataPipe.transform(targetTimestamp, format);
    }
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/pipes/peking-date.pipe.ts